

const Copyright = () => {
  const year = new Date().getUTCFullYear();
  return (
    <span>&copy; {year} Lauri Mikael</span>
  )
};

export default Copyright;